type Severity = 'info' | 'ok' | 'warn' | 'crit' | 'neutral'

const severityStyles: Record<Severity, string> = {
  neutral: 'text-slate-700 border-slate-200 bg-slate-100 font-semibold',
  info: 'text-sky-700 border-sky-200 bg-sky-50 font-semibold',
  ok: 'text-emerald-700 border-emerald-200 bg-emerald-50 font-bold',
  warn: 'text-amber-800 border-amber-300 bg-amber-50 font-bold shadow-2xs',
  crit: 'text-rose-700 border-rose-200 bg-rose-50 font-bold',
}

const dotStyles: Record<Severity, string> = {
  neutral: 'bg-slate-400',
  info: 'bg-sky-500',
  ok: 'bg-emerald-500',
  warn: 'bg-amber-500 animate-pulse',
  crit: 'bg-rose-500',
}

// Maps common status strings across the app to a consistent color language.
function inferSeverity(status: string): Severity {
  const s = (status || '').toLowerCase()
  if (['completed', 'success', 'active', 'signed', 'ok'].includes(s)) return 'ok'
  if (['pending', 'sent', 'viewed', 'draft', 'info', 'in_progress'].includes(s)) return 'info'
  if (['warning', 'warn', 'expired'].includes(s)) return 'warn'
  if (['failure', 'failed', 'declined', 'voided', 'critical', 'crit', 'suspended', 'locked', 'disabled'].includes(s))
    return 'crit'
  return 'neutral'
}

export function StatusBadge({ status, label }: { status: string; label?: string }) {
  const severity = inferSeverity(status)
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-md px-2.5 py-0.5 text-[10.5px] font-mono border shadow-2xs ${severityStyles[severity]}`}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${dotStyles[severity]}`} />
      <span>{(label ?? status).toUpperCase()}</span>
    </span>
  )
}
